<template>
  <div class="carousel-container" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
    <div class="carousel-wrapper" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
    <!--      <div class="carousel-item" v-for="(item, index) in items" :key="index">-->
    <!--        <img :src="item.image" :alt="item.title">-->
    <!--        <div class="carousel-caption" v-if="item.title">-->
    <!--          <h3>{{ item.title }}</h3>-->
    <!--          <p v-if="item.description">{{ item.description }}</p>-->
    <!--        </div>-->
    <!--      </div>-->
      <slot></slot>
    </div>

    <!-- 左右箭头 -->
<!--    <div class="carousel-arrow carousel-arrow-left" @click="prev">-->
<!--      <i class="arrow-icon">&#10094;</i>-->
<!--    </div>-->
<!--    <div class="carousel-arrow carousel-arrow-right" @click="next">-->
<!--      <i class="arrow-icon">&#10095;</i>-->
<!--    </div>-->

    <!-- 指示器 -->
    <div class="carousel-indicators">
      <span
          v-for="(item, index) in items"
          :key="index"
          :class="{ active: currentIndex === index }"
          @click="goToSlide(index)">
      </span>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Carousel',
  props: {
    // 轮播项数据
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    // 自动轮播间隔时间(毫秒)
    interval: {
      type: Number,
      default: 1000
    },
    // 是否自动轮播
    autoplay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null
    }
  },
  mounted() {
    if (this.autoplay) {
      this.startAutoPlay()
    }
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    // 下一张
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length
    },
    // 上一张
    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length
    },
    // 跳转到指定幻灯片
    goToSlide(index) {
      this.currentIndex = index
    },
    // 开始自动轮播
    startAutoPlay() {
      if (this.autoplay && this.items.length > 1) {
        this.timer = setInterval(() => {
          this.next()
        }, this.interval)
      }
    },
    // 停止自动轮播
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style scoped>
.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 4px;
}

.carousel-wrapper {
  display: flex;
  transition: transform 0.5s ease;
  height: 100%;
}

.carousel-item {
  flex: 0 0 100%;
  position: relative;
}

.carousel-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.carousel-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 15px;
}

.carousel-caption h3 {
  margin: 0 0 10px;
  font-size: 18px;
}

.carousel-caption p {
  margin: 0;
  font-size: 14px;
}

.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  font-size: 18px;
  z-index: 10;
  transition: background 0.3s;
}

.carousel-arrow:hover {
  background: rgba(0, 0, 0, 0.6);
}

.carousel-arrow-left {
  left: 10px;
}

.carousel-arrow-right {
  right: 10px;
}

.carousel-indicators {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}

.carousel-indicators span {
  width: 8px;
  height: 8px;
  background: rgba(2,86,255,0.2);
  cursor: pointer;
  transition: background 0.3s;
}

.carousel-indicators span.active {
  width: 24px;
  height: 8px;
  background: #0256FF;
}
</style>
